export default "__VITE_ASSET__BEjlUk6w__"